var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 42a3 3 0 013-3h40a3 3 0 110 6H4a3 3 0 01-3-3zM1 6a3 3 0 013-3h40a3 3 0 110 6H4a3 3 0 01-3-3zM1 24a3 3 0 013-3h40a3 3 0 110 6H4a3 3 0 01-3-3z",
    fill: "#35313F"
  })));
}

export default SvgList;